export const NO_TEAM = "Aucune équipe";
